
import { Component, Prop, Vue } from "vue-property-decorator";
import { TopicModel } from "@/models/TopicModel";
import { Helpers } from "@/global-scripts/helpers";
import { getModule } from "vuex-module-decorators";
import FilterModule from "@/store/modules/FilterModule";
import ContentModule from "@/store/modules/ContentModule";

@Component
export default class RelatedTopics extends Vue {
  private readonly filterModule = getModule(FilterModule, this.$store);
  private readonly contentModule = getModule(ContentModule, this.$store);

  @Prop()
  data!: TopicModel[];

  private get basePath(): string {
    return this.filterModule.basePath;
  }

  private get topicData(): TopicModel[] {
    return (this.data || []).filter(t => t);
  }

  private getTopicUrlName(topic: TopicModel): string {
    return Helpers.urlFriendlyName(topic.title);
  }

  private getTopicCategoryPath(categoryId: string, topic: TopicModel): string {
    return Helpers.categoryBreadCrumb(categoryId, this.contentModule.filteredCategories);
  }

  private parentCategoryTitle(categoryId: string | number): string {
    const category = this.contentModule.categoryByID(categoryId);
    return category ? category.title : "";
  }
}
